import './ContactUs.css';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { WalletContext } from './WalletContext';

function ContactUs({ onBack, contactNumber = '8000673615', whatsappUrl = 'https://wa.me/918000673615' }) {
  const navigate = useNavigate();
  const { walletBalance } = useContext(WalletContext);

  return (
    <div className="contact-us-page">
      {/* Header */}
      <div className="contact-us-header">
        <button className="back-btn" onClick={onBack}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </button>
        <h1>Contact Us</h1>
        <button className="wallet-btn" onClick={() => navigate("/funds")}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <rect x="2" y="6" width="20" height="14" rx="2" stroke="white" strokeWidth="2"/>
            <path d="M2 10H22" stroke="white" strokeWidth="2"/>
            <circle cx="18" cy="15" r="1.5" fill="white"/>
          </svg>
          <span className="wallet-balance">₹ {walletBalance}</span>
        </button>
      </div>

      {/* Content */}
      <div className="contact-us-content">
        {/* Contact Card */}
        <div className="contact-card">
          <h2 className="contact-card-title">Contact Us</h2>
          
          {/* Mobile Number */}
          <a href={`tel:${contactNumber}`} className="contact-item" style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className="contact-info">
              <span className="contact-label">Mobile No.</span>
              <span className="contact-value">{contactNumber}</span>
            </div>
            <div className="contact-action-btn call" style={{ border: 'none', background: 'none', cursor: 'pointer' }}>
              <svg width="28" height="28" viewBox="0 0 28 28" fill="white">
                <path d="M9 4C8.5 4 8 4.5 7 6C6 7.5 6 8.5 7 10C8 11.5 10 14 13 17C16 20 18.5 22 20 23C21.5 24 22.5 24 24 23C25.5 22 26 21.5 26 21C26 20.5 25 19 24 18C23 17 22 16.5 21 17C20 17.5 19.5 18 18.5 17.5C17.5 17 15.5 15.5 14 14C12.5 12.5 11 10.5 10.5 9.5C10 8.5 10.5 8 11 7C11.5 6 11 5 10 4C9 3 9.5 4 9 4Z" stroke="white" strokeWidth="1.5"/>
              </svg>
            </div>
          </a>

          {/* WhatsApp */}
          <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="contact-item" style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className="contact-info">
              <span className="contact-label">WhatsApp</span>
              <span className="contact-value">{contactNumber}</span>
            </div>
            <div className="contact-action-btn whatsapp" style={{ border: 'none', background: 'none', cursor: 'pointer' }}>
              <svg width="28" height="28" viewBox="0 0 28 28" fill="white">
                <path d="M14 2C7.4 2 2 7.4 2 14C2 16.4 2.7 18.6 3.9 20.5L2.2 25.8L7.7 24.1C9.5 25.2 11.7 26 14 26C20.6 26 26 20.6 26 14C26 7.4 20.6 2 14 2ZM19.5 18.5C19.2 19.3 18.1 20 17.3 20.2C16.8 20.3 16.2 20.4 13.8 19.4C10.7 18.2 8.7 15.1 8.5 14.9C8.3 14.7 7 13 7 11.2C7 9.4 7.9 8.5 8.2 8.2C8.5 7.9 8.9 7.8 9.2 7.8C9.3 7.8 9.5 7.8 9.6 7.8C9.9 7.8 10.1 7.8 10.3 8.3C10.6 8.9 11.2 10.7 11.3 10.8C11.4 10.9 11.4 11.1 11.3 11.3C11.2 11.5 11.1 11.6 10.9 11.8C10.7 12 10.6 12.1 10.4 12.3C10.2 12.5 10 12.7 10.2 13C10.4 13.3 11.2 14.6 12.4 15.6C13.9 16.9 15.1 17.3 15.5 17.5C15.8 17.6 16.1 17.6 16.3 17.4C16.5 17.2 17.1 16.5 17.3 16.2C17.5 15.9 17.8 15.9 18.1 16.1C18.4 16.2 20.2 17.1 20.5 17.3C20.8 17.4 21 17.5 21.1 17.6C21.2 17.8 21.2 18.3 19.5 18.5Z"/>
              </svg>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
